import React from "react";
import { RadioGroup, Radio } from "@headlessui/react";
import { motion, AnimatePresence } from "framer-motion";
import { useFetchPaymentCycles } from "../../../../utils/fetchAddons";
import { usePageSettings } from "../../../../contexts/PageSettingsContext";

// Fade-up animation variants
const fadeInUp = {
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	exit: { opacity: 0 },
};

export default function PaymentCyclesRadioList({
	currency,
	addons = [],
	selectedPaymentCycle,
	onPaymentCycleChange,
	count
}) {
	const { data: paymentCyclesData, isSuccess } = useFetchPaymentCycles(currency, addons, count);
	const { translations } = usePageSettings();

	return (
		<AnimatePresence>
			<motion.div key="paymentCyclesList" variants={fadeInUp} initial="initial" animate="animate" exit="exit">
				{isSuccess ? (
					<RadioGroup
						className="grid grid-cols-1 md:grid-cols-2 !gap-8"
						value={selectedPaymentCycle}
						onChange={onPaymentCycleChange}
					>
						{paymentCyclesData?.map((payment) => (
							<PaymentRadioItem key={payment.cycle} payment={payment} translations={translations} />
						))}
					</RadioGroup>
				) : (
					<PaymentSkeleton translations={translations} />
				)}
			</motion.div>
		</AnimatePresence>
	);
}

// Child radio item
const PaymentRadioItem = ({ payment, translations }) => (
	<Radio
		value={payment.cycle}
		className="group hover:cursor-pointer relative flex items-center cursor-pointer h-[52px] 
               px-5 py-2.5 bg-zinc-900 rounded-lg border border-zinc-800 text-white shadow-md 
               transition focus:outline-none data-[focus]:outline-1 data-[focus]:outline-white 
               data-[checked]:bg-white/10"
	>
		<span className="w-2.5 h-2.5 mr-2.5 rounded-full bg-transparent border border-ipxon-magenta group-data-[checked]:bg-ipxon-magenta" />
		<div className="text-zinc-200 text-sm capitalize w-full justify-between flex">
			<span>{translations[payment.cycle] || payment.cycle}</span>
			<div className="flex gap-2">
				<span className="uppercase">{payment.price}</span>
				<span className="text-ipxon-magenta">
					{payment.cycle !== "monthly" &&
						(translations["PaymentDiscount"] || "* Save") + " " + payment.discount}
				</span>
			</div>
		</div>
	</Radio>
);

// Skeleton / loading state
const PaymentSkeleton = ({ translations }) => (
	<div className="grid grid-cols-1 md:grid-cols-2 gap-8 animate-pulse duration-500">
		{Array.from({ length: 2 }).map((_, i) => (
			<SkeletonItem key={i} translations={translations} />
		))}
	</div>
);

const SkeletonItem = ({ translations }) => (
	<span className="group hover:cursor-pointer relative flex items-center cursor-pointer h-[52px] px-5 py-2.5 bg-zinc-900 rounded-lg border border-zinc-800 text-white shadow-md ">
		<span className="w-2.5 h-2.5 mr-2.5 rounded-full bg-zinc-800" />
		<div className="text-zinc-200 text-sm capitalize w-full justify-between flex">
			<span className="bg-zinc-800 rounded-lg opacity-100 w-16 h-4"></span>
			<span className="bg-zinc-800 rounded-lg opacity-100 w-12 h-4"></span>
		</div>
	</span>
);
